module.exports = __webpack_public_path__ + "static/media/glucose-top.f9010658.png";